import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyGAWelcomeModal: FunctionComponent = () => {
  const GAWelcomeModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-ga-welcome-modal" */ './GAWelcomeModal'
      ),
    { namedImport: 'GAWelcomeModal', preload: false },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <GAWelcomeModal />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
